import React, { useState } from 'react';
import './PriceBreakdownView.css';
import DOMPurify from 'dompurify';

const ExpandableSection = ({ title, children, defaultExpanded = false }) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <div className={`breakdown-section expandable ${isExpanded ? 'expanded' : ''}`}>
      <button className="section-header" onClick={() => setIsExpanded(!isExpanded)}>
        <h3 className="breakdown-section-title">{title}</h3>
        <svg className="chevron" viewBox="0 0 24 24"><path d="M7 10l5 5 5-5z" /></svg>
      </button>
      <div className="section-content">
        {children}
      </div>
    </div>
  );
};

const PriceBreakdownView = ({ breakdown, onClose, title, isModal = false }) => {
  if (!breakdown) {
    return null;
  }

  const {
    nightly,
    taxesAndFees,
    totalPrice,
    rateName,
    rateDescription,
    policies
  } = breakdown;

  const content = (
    <>
      {/* Rate Title and Description */}
      {rateName && <div className="room-name">{rateName}</div>}
      {rateDescription && <div className="rate-description-modal">{rateDescription}</div>}

      <ExpandableSection title="BASE PRICE" defaultExpanded={true}>
        {nightly.map((night, index) => (
          <div className="breakdown-item" key={index}>
            <span>{new Date(night.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}</span>
            <span>${night.price.toFixed(2)}</span>
          </div>
        ))}
      </ExpandableSection>
      
      <ExpandableSection title="TAXES & FEES" defaultExpanded={true}>
        {taxesAndFees.map((item, index) => (
           <div className="breakdown-item tax-item" key={index}>
            <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(
              `${item.name}${item.details ? `<small>${item.details}</small>` : ''}`
            )}} />
            <span>${item.amount.toFixed(2)}</span>
          </div>
        ))}
      </ExpandableSection>
      
      <div className="breakdown-section total-section">
        <div className="breakdown-item total-price">
          <span>TOTAL PRICE</span>
          <span>${totalPrice.toFixed(2)}</span>
        </div>
      </div>

      {/* Policies Section */}
      {policies && policies.length > 0 && (
        <div className="breakdown-section">
          <h3 className="breakdown-section-title">POLICIES</h3>
          <ul className="policies-list">
            {policies.map((policy, idx) => (
              <li key={idx} className="policy-list-item">
                <span className="policy-name">{policy.name}</span>
                {policy.text && Array.isArray(policy.text) && (
                  <div className="policy-text-modal">
                    {policy.text.map((t, i) => (
                      <div key={i} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t) }} />
                    ))}
                  </div>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );

  if (isModal) {
    return (
      <div className="price-breakdown-view">
        <div className="price-breakdown-content" onClick={(e) => e.stopPropagation()}>
          <div className="price-breakdown-header">
            <div className="header-left-spacer"></div>
            <h2 className="price-breakdown-title">{title || 'Price Breakdown'}</h2>
            <button className="price-breakdown-done" onClick={onClose}>
              Done
            </button>
          </div>
          <div className="price-breakdown-body">
            {content}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="price-breakdown-inline-view">
      {content}
    </div>
  );
};

export default PriceBreakdownView; 